export default "__VITE_ASSET__f45990ac__"